// extracted by mini-css-extract-plugin
export var errorIcon = "_j3-1";
export var nameLogo = "_j3-0";